<template lang="pug">
.cart-item.play-card-item
  .summary__line
    .summary__prod.summary__prod--left
      p {{ getProductTitle() }}
      template(v-for="(count, name) in payload.options.upgrades || {}")
        p(v-if="count") {{ upgrades.find(x => x.name == name).title }} {{ count }}
      p.summary__time.hidden
      p.summary_time-hide
      a.summary__edit(href='#' @click.prevent="itemEdit($event)") Edit
      a.summary_delete-hide.summary__edit(href='#' @click.prevent="itemDelete($event)") DELETE
    .summary__prod
      p -
    .summary__prod
      p.summary__price-sp.nowrap {{ item.attributes.product.price | currency }}
      p.summary__subtotal-price-hide.nowrap {{ (item.total * 1) + (item.attributes.product.tax_amount * item.payload.count) | currency }}
      .summary__calc
        button.minus-count.summary__minus(:class="{ disabled: item.payload.count <= 1 }" @click="setCount(item.payload.count - 1)")
        p.nowrap {{ item.payload.count }}
        button.plus-count.summary__plus(@click="setCount(item.payload.count + 1)")
    .summary__prod.summary__price
      p.nowrap {{ item.attributes.product.price | currency }}
    .summary__prod
      p.nowrap {{ item.attributes.product.price * item.payload.count + upgradePrice | currency }}
    .summary__prod
      p.nowrap {{ item.attributes.product.tax * item.payload.count | currency }}
    .summary__prod.summary__prod--right.summary__prod--last
      p.nowrap {{ (Number(item.attributes.product.price) + Number(item.attributes.product.tax)) * item.payload.count + upgradePrice | currency }}
      button.summary__remove-product(@click.prevent="itemDelete($event)")
</template>

<script>
const EventBus = window.VueEventBus
import PageMixins from '../../components/_mixins/pages'
import CartMixins from '../../components/_mixins/location-checkout'
import DatesMixin from '../../components/_mixins/dates'

export default {
  name: 'playcard-reload-cart-item',
  settings: 'page.cart',
  translations: 'page.cart',
  mixins: [
    PageMixins,
    CartMixins,
    DatesMixin,
  ],

  props: {
    item: {},
    items: {},
    groupedItems: {},
    cartView: {},
    showItemRates: {
      default: false
    },
  },

  computed: {
    payload() {
      return this.item.payload
    },
    upgrades() {
      return this.item.attributes.product.upgrades
    },
    upgradePrice() {
      return Object.entries(this.item.payload.options.upgrades || {})
            .map(([name, count]) => this.upgrades.find(u => u.name == name).price * count)
            .reduce((sum, a) => sum + a, 0)
    },
  },

  methods: {
    itemDelete($event) {
      const item = this.item
      this.cartView.cartItemButtonClicked({
        $event,
        actionName: 'delete',
        id: this.item.id,
        item,
        cartItems: this.currentCartItems,
        button: {}
      })

      EventBus.$emit('cart-item-deleted', item, this, this.$parent)
      EventBus.$emit('cart-item-deleted-' + item.type, item, this, this.$parent)
    },

    itemEdit($event) {
      const item = this.item
      this.cartView.cartItemButtonClicked({
        $event,
        item,
        actionName: 'edit',
        id: this.item.id,
        cartItems: this.currentCartItems,
        button: {}
      })
      EventBus.$emit('cart-item-edit', item, this, this.$parent)
      EventBus.$emit('cart-item-edit-' + item.type, item, this, this.$parent)

      this.$router.push({ name: 'supercharged.reload-play-card', query: { item: item.id } })
    },

    setCount(count) {
      EventBus.$emit('cart.validating', true)
      this.setCartItemCount({ id: this.item.id, count })
      EventBus.$$emitAsync('cart.validate')
      EventBus.$emit('cart.validating', false)
    },
    getProductTitle() {
      const item = this.item
      const title = item.attributes.product.title
      return title.replace(/play card/ig, this.PLAYCARD_TC)
    }
  }
}
</script>
